import { createSelector } from 'reselect'

const pollSelector = state => state.poll

const saveSelector = createSelector(
	[pollSelector],
	poll => ({
		entityUID: poll.entityUID,
		allIconsDone: poll.questions.filter(question => question.icon.status === 'uploading').length===0,
		allQuestionsDone: poll.questions.filter(question => question.status === 'saving' || question.status === 'deleting').length===0,
	})
)

export default saveSelector
